import { Empty, Typography } from 'antd';
import React, { ReactNode } from 'react';

import NoResultsIcon from 'ac-components/ac-icons/NoResultsIcon';

import './WidgetEmpty.less';

type Props = {
  description?: string | ReactNode;
};

export const NO_DATA_AVAILABLE = 'Nothing matches your search';

export const WidgetEmpty = ({ description = NO_DATA_AVAILABLE }: Props) => {
  return (
    <div className="ac-empty-widget d-flex align-items-center justify-content-center h-100">
      <Empty
        description={
          <Typography.Text style={{ color: '#5C5C5C' }}>
            {description}
          </Typography.Text>
        }
        image={<NoResultsIcon />}
      />
    </div>
  );
};
